var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"black","dark":""},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("Back")])}
var staticRenderFns = []

export { render, staticRenderFns }